module.exports = __webpack_public_path__ + "img/avatar.e40389c9.svg";